

import { Component } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Skill, SkillAdapter } from '../models/skill';
import { People } from '../models/people';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { SkillsService } from '../services/skills.service';
import { EventsService } from '../services/events.service';
import { Event, EventAdapter } from '../models/event';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { TranslatePipe } from '@ngx-translate/core';
import { EventsComponent } from '../_utils/components/events/events.component';
import { AvatarComponent } from '../_utils/components/avatar/avatar.component';
import { PeopleStatusComponent } from '../_utils/components/people-status/people-status.component';
import { PeopleStatusIconComponent } from '../_utils/components/people-status-icon/people-status-icon.component';
import { getPersonHiringStatusClass, getPersonStatusIconAndMessage } from '../_utils/people_util';

@Component({
  selector: 'app-skill',
  standalone: true,
  imports: [CommonModule, RouterModule,  CardModule, TranslatePipe, EventsComponent, AvatarComponent, PeopleStatusComponent, PeopleStatusIconComponent],
  templateUrl: './skill.component.html',
  styleUrl: './skill.component.scss'
})
export class SkillComponent {

  private skillObservable!: Observable<Skill> ;
  private eventObservable!: Observable<Event[]> ;
  skillId: number = 0;
  skill?: Skill;
  // peoples: People[]=[];
  events: Event[]=[];

  //method mapping for template access
  public getPersonHiringStatusClass = getPersonHiringStatusClass;
  public getPersonStatusIconAndMessage = getPersonStatusIconAndMessage;

  constructor(private route: ActivatedRoute,
    private skillsService : SkillsService, 
    private skillAdapter: SkillAdapter,
    private eventsService: EventsService,
    private eventAdapter: EventAdapter,
) { }

  ngOnInit(): void{
    this.skillId = this.route.snapshot.params['id'];
    this.fecthSkill();

  }

  
  fecthSkill() {
    this.skillObservable = this.skillsService.getSkill(this.skillId).pipe(
      map((item:any) => this.skillAdapter.adapt(item))
    );

    this.skillObservable.subscribe(
      (res: Skill) => {
      this.skill = res;

    });
  }

  trackByTeam(index: number, team: any): number {
    return team.id;
  }
}
